const timestampNow = () => Math.floor(+new Date() / 1000);

export const isTokenExpired = (expires: number): boolean => (expires ? expires - timestampNow() < 0 : true);
